import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import styles from './ArchiveDetail.module.scss'
import UniversityArchive from './components/UniversityArchive'
import StudentArchive from './components/StudentArchive'
import EmployeeArchive from './components/EmployeeArchive'
import { Button, Layout } from "components/index";
import { getActivityLog } from 'service/ArchiveService'
import { ScaleLoader } from 'react-spinners'

function ActivityLog() {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')

  useEffect(() => {
    loadLogs()
  }, [filter])

  const loadLogs = async () => {
    try {
      setLoading(true)
      const archiveType = filter === 'all' ? null : filter
      const data = await getActivityLog(archiveType)
      setLogs(data)
    } catch (error) {
      console.error('Ошибка при загрузке журнала:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className={styles.loading_container}>
        <ScaleLoader color="#9966cc" />
      </div>
    )
  }

  return (
    <div className={styles.activity_log}>
      <h2>Журнал действий</h2>
      
      <div className={styles.filter_bar}>
        <button
          className={`${styles.btn_filter} ${filter === 'all' ? styles.active : ''}`}
          onClick={() => setFilter('all')}
        >
          Все
        </button>
        <button
          className={`${styles.btn_filter} ${filter === 'university' ? styles.active : ''}`}
          onClick={() => setFilter('university')}
        >
          Университет
        </button>
        <button
          className={`${styles.btn_filter} ${filter === 'student' ? styles.active : ''}`}
          onClick={() => setFilter('student')}
        >
          Студенты
        </button>
        <button
          className={`${styles.btn_filter} ${filter === 'employee' ? styles.active : ''}`}
          onClick={() => setFilter('employee')}
        >
          Сотрудники
        </button>
      </div>

      <div className={styles.log_entries}>
        {logs.length > 0 ? (
          logs.map((log) => (
            <div key={log.id} className={styles.log_entry}>
              <div className={styles.log_header}>
                <span className={styles.log_action}>
                  {log.action_type} • {log.archive_type}
                </span>
                <span className={styles.log_time}>
                  {new Date(log.timestamp).toLocaleString('ru-RU')}
                </span>
              </div>
              <div className={styles.log_details}>
                <p><strong>Объект:</strong> {log.entity_name}</p>
                {log.description && <p>{log.description}</p>}
                <p>
                  {log.employee && <span>Пользователь: ID {log.employee}</span>}
                  {log.ip_address && <span> • IP: {log.ip_address}</span>}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p className={styles.no_logs}>Записей не найдено</p>
        )}
      </div>
    </div>
  )
}

function ArchiveDetail() {
  const { archiveType } = useParams()
  const navigate = useNavigate()

  const renderArchiveComponent = () => {
    switch (archiveType) {
      case 'university':
        return <UniversityArchive />
      case 'students':
        return <StudentArchive />
      case 'employees':
        return <EmployeeArchive />
      case 'logs':
        return <ActivityLog />
      default:
        return <div>Неизвестный тип архива</div>
    }
  }

  return (
    <Layout>
    <div className={styles.archive_detail}>
      <div className={styles.nav_header}>
        <button className={styles.btn_back} onClick={() => navigate('/archive/')}>
          ← Вернуться в архив
        </button>
      </div>
      {renderArchiveComponent()}
    </div>
    </Layout>
  )
}

export default ArchiveDetail
